/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface Room {
  readonly id: string;
  readonly name: string;
  readonly capacity: number | null;
  readonly active: boolean;
  readonly sortOrder: number;
  readonly createdAt: string;
}

export interface CreateRoomPayload {
  readonly name: string;
  readonly capacity?: number;
  readonly sortOrder?: number;
}

export interface UpdateRoomPayload {
  readonly name?: string;
  readonly capacity?: number;
  readonly active?: boolean;
  readonly sortOrder?: number;
}

const BASE = '/rooms';

export const roomsApi = {
  async list(activeOnly = false): Promise<readonly Room[]> {
    const { data } = await apiClient.get<readonly Room[]>(BASE, {
      params: activeOnly ? { active: '1' } : {},
    });
    return data;
  },
  async create(payload: CreateRoomPayload): Promise<Room> {
    const { data } = await apiClient.post<Room>(BASE, payload);
    return data;
  },
  async update(id: string, payload: UpdateRoomPayload): Promise<Room> {
    const { data } = await apiClient.patch<Room>(`${BASE}/${id}`, payload);
    return data;
  },
};
